<div class="wf-conditions">
  <app-workflow-conditions-group
    [variables]="variables"
    [group]="value"
    [removable]="false"
    (groupChange)="onGroupChange($event)"></app-workflow-conditions-group>
  
</div>


